// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-modal .ant-modal-content {
  min-width: 800rem;
}
@media (max-width: 660px) {
  .ant-modal .ant-modal-content {
    min-width: 300rem;
  }
}
video.video,
iframe[title='YouTube video player'] {
  z-index: 1000;
  width: 100%;
  height: 400rem;
  opacity: 1;
}
ul.ant-list-items {
  overflow: auto;
  height: 200rem;
}
.btn-timecode {
  color: #07456F;
  transition: color 0.1s ease-in;
}
.btn-timecode:hover {
  color: #69b1ff;
}
@media (max-width: 660px) {
  .ant-modal {
    min-width: 200rem;
  }
  video.video,
  iframe[title='YouTube video player'] {
    z-index: 1000;
    width: 100%;
    height: 150rem;
    opacity: 1;
  }
}
.video-description-list li {
  list-style: disc;
  margin-inline-start: 40rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/WebinarsPage/ui/VideoModal/VideoModal.style.less"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AAEA;EACI;IACI,iBAAA;EAAN;AACF;AAGA;;EAEI,aAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;AADJ;AAIA;EACI,cAAA;EACA,cAAA;AAFJ;AAKA;EACI,cAAA;EACA,8BAAA;AAHJ;AAKI;EACI,cAAA;AAHR;AAOA;EACI;IACI,iBAAA;EALN;EAQE;;IAEI,aAAA;IACA,WAAA;IACA,cAAA;IACA,UAAA;EANN;AACF;AASA;EAEQ,gBAAA;EACA,0BAAA;AARR","sourcesContent":[".ant-modal .ant-modal-content {\n    min-width: 800rem;\n}\n\n@media (max-width: 660px) {\n    .ant-modal .ant-modal-content {\n        min-width: 300rem;\n    }\n}\n  \nvideo.video,\niframe[title = 'YouTube video player'] {\n    z-index: 1000;\n    width: 100%;\n    height: 400rem;\n    opacity: 1;\n}\n  \nul.ant-list-items {\n    overflow: auto;\n    height: 200rem;\n}\n  \n.btn-timecode {\n    color: #07456F;\n    transition: color .1s ease-in;\n  \n    &:hover {\n        color: #69b1ff;\n    }\n}\n  \n@media (max-width: 660px) {\n    .ant-modal {\n        min-width: 200rem;\n    }\n  \n    video.video,\n    iframe[title = 'YouTube video player']  {\n        z-index: 1000;\n        width: 100%;\n        height: 150rem;\n        opacity: 1;\n    }\n}\n\n.video-description-list {\n    li {\n        list-style: disc;\n        margin-inline-start: 40rem;\n    }\n}\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
